/**
 * Le Righe — animazioni allo scorrimento.
 *
 * - Comparsa a cascata: gli elementi entrano dal basso in dissolvenza quando
 *   arrivano nello schermo; quelli che entrano insieme si sfalsano di poco.
 * - Zoom-out: le immagini grandi partono leggermente ingrandite e si assestano.
 * - Parallasse: l'immagine dell'hero si ingrandisce piano mentre si scorre.
 * - Card impilate: le card che restano "sotto" si rimpiccioliscono e scuriscono.
 * - Vetrina scorrevole: il titolo centrale cambia frase mentre si scorre.
 * - Linee in evidenza: la parola attiva (scorrimento o mouse) cambia la foto.
 *
 * Gli elementi animati sono scelti in automatico (testi, pulsanti, card prodotto
 * e collezione) oppure segnati a mano con data-righe-motion="fade-up|fade|zoom-out".
 * I selettori devono restare allineati con lo stato iniziale definito in righe.css.
 *
 * Le comparse funzionano solo con html.righe-motion (animazioni attive e nessuna
 * richiesta di movimento ridotto); le sezioni guidate dallo scorrimento funzionano
 * sempre, perché cambiano contenuto e non sono solo decorazione.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var motionOn = root.classList.contains('righe-motion');

  var SELECTORS = [
    'main .text-block:not(product-card *)',
    'main a.size-style[class*="button"]:not(product-card *)',
    'main .resource-list__item',
    'main .righe-story__text > p',
    'main .hero__media-grid',
    'main [data-righe-motion]',
  ].join(',');

  var STAGGER_MS = 70;
  var STAGGER_MAX = 16;
  var observed = new WeakSet();

  function reveal(entries) {
    var visible = entries
      .filter(function (e) { return e.isIntersecting; })
      .map(function (e) { return e.target; })
      .sort(function (a, b) {
        var ra = a.getBoundingClientRect();
        var rb = b.getBoundingClientRect();
        return ra.top - rb.top || ra.left - rb.left;
      });

    visible.forEach(function (el, i) {
      var extra = parseInt(el.getAttribute('data-righe-delay') || '0', 10);
      el.style.setProperty('--righe-delay', Math.min(i, STAGGER_MAX) * STAGGER_MS + extra + 'ms');
      el.classList.add('is-inview');
      io.unobserve(el);
    });
  }

  var io = new IntersectionObserver(reveal, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  /* Schede prodotto: la prima foto si carica subito; finito il caricamento della pagina,
     le altre foto di ogni scheda si scaricano in sottofondo, a piccoli gruppi, così al
     passaggio del mouse (o scegliendo un colore) cambiano senza attesa. Vale anche per
     le schede aggiunte dopo (scorrimento infinito, filtri). */
  var paginaCaricata = document.readyState === 'complete';
  var precaricoInCorso = false;

  function precaricaSchede() {
    if (!paginaCaricata || precaricoInCorso) return;
    // Solo con il mouse: su telefono non c'è passaggio del mouse, e scaricare tutte le foto
    // delle schede (150 per vederne 9 in "Shop") appesantiva il 4G e la memoria degli iPhone.
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var foto = Array.prototype.slice.call(document.querySelectorAll('.card-gallery img[loading="lazy"]'));
    if (!foto.length) return;
    precaricoInCorso = true;
    var attesa = window.requestIdleCallback || function (fn) { return setTimeout(fn, 150); };
    (function lotto() {
      foto.splice(0, 12).forEach(function (img) { img.loading = 'eager'; });
      if (foto.length) return attesa(lotto);
      // Finito: si ricontrolla per eventuali schede arrivate nel frattempo.
      precaricoInCorso = false;
      precaricaSchede();
    })();
  }

  window.addEventListener('load', function () {
    paginaCaricata = true;
    precaricaSchede();
  });

  function scan() {
    precaricaSchede();
    if (motionOn) {
      document.querySelectorAll(SELECTORS).forEach(function (el) {
        if (observed.has(el)) return;
        observed.add(el);
        io.observe(el);
      });
      revealInViewport();
    }
    setupStacks();
    update();
  }

  /* Rivela subito ciò che è già nello schermo, senza aspettare l'observer
     (che nelle schede in background può partire in ritardo). */
  function revealInViewport() {
    if (!motionOn) return;
    var vh = window.innerHeight;
    var entries = [];
    document.querySelectorAll(SELECTORS).forEach(function (el) {
      if (el.classList.contains('is-inview')) return;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.bottom > 0 && r.top < vh * 0.92) {
        entries.push({ isIntersecting: true, target: el });
      }
    });
    if (entries.length) reveal(entries);
  }

  /* ---------------------------------------------------------- scroll FX */

  var heroMedia = null;
  var stacks = [];
  var rolls = [];
  var spreads = [];
  var wordSections = [];
  var ticking = false;
  var bound = new WeakSet();

  function setupStacks() {
    heroMedia = document.querySelector('main > .shopify-section:first-child .hero__media-grid');
    stacks = Array.prototype.slice.call(document.querySelectorAll('[data-righe-stack]'));
    rolls = Array.prototype.slice.call(document.querySelectorAll('[data-righe-roll]'));
    wordSections = Array.prototype.slice.call(document.querySelectorAll('[data-righe-words]'));
    wordSections.forEach(bindWordHover);
    document.querySelectorAll('[data-righe-roll-slider]').forEach(bindRollSlider);
    document.querySelectorAll('[data-righe-autoscorri]').forEach(bindAutoScorri);
    spreads = Array.prototype.slice.call(document.querySelectorAll('[data-righe-spread]'));
    spreads.forEach(function (lista) {
      if (reducedMotion()) return;
      misuraSpread(lista);
      lista.classList.add('is-spread');
    });
    bindMegaMenus();
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function clamp01(v) {
    return Math.min(Math.max(v, 0), 1);
  }

  /* Fa "sostare" il valore su ogni intero e passa al successivo in modo morbido. */
  function holdAndGlide(value) {
    var i = Math.floor(value);
    var f = value - i;
    var t = clamp01((f - 0.3) / 0.4);
    return i + t * t * (3 - 2 * t);
  }

  /* Vetrina scorrevole: titolo che scorre e colonne in leggera parallasse. */
  function updateRoll(section, vh) {
    var grid = section.querySelector('.righe-roll__grid');
    var rect = grid.getBoundingClientRect();
    var n = parseInt(getComputedStyle(section).getPropertyValue('--slides'), 10) || 1;
    var p = clamp01((vh * 0.5 - rect.top) / rect.height);
    var roll = Math.min(Math.max(p * n - 0.5, 0), n - 1);
    section.style.setProperty('--righe-roll', holdAndGlide(roll).toFixed(4));
    section.style.setProperty('--righe-roll-p', p.toFixed(4));
  }

  /* Menu del telefono: le voci con sottovoci aprono un pannello da destra
     (snippets/righe-drawer-sottomenu.liquid); le frecce delle categorie aprono e
     chiudono l'anteprima dei prodotti. */
  function chiudiSottomenu(pannello) {
    pannello.classList.remove('is-open');
    pannello.setAttribute('inert', '');
    var drawer = pannello.closest('.menu-drawer');
    if (drawer) drawer.classList.remove('righe-sub-aperto');
    var apri = document.querySelector('[aria-controls="' + pannello.id + '"][data-righe-sub-open]');
    if (apri) apri.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var apri = e.target.closest('[data-righe-sub-open]');
    if (apri) {
      var pannello = document.getElementById(apri.getAttribute('aria-controls'));
      if (!pannello) return;
      var drawer = pannello.closest('.menu-drawer');
      if (drawer) {
        drawer.scrollTop = 0;
        drawer.classList.add('righe-sub-aperto');
      }
      pannello.removeAttribute('inert');
      pannello.classList.add('is-open');
      apri.setAttribute('aria-expanded', 'true');
      var indietro = pannello.querySelector('[data-righe-sub-back]');
      if (indietro) setTimeout(function () { indietro.focus({ preventScroll: true }); }, 50);
      return;
    }
    var back = e.target.closest('[data-righe-sub-back]');
    if (back) {
      chiudiSottomenu(back.closest('[data-righe-sub]'));
      return;
    }
    var freccia = e.target.closest('[data-righe-sub-toggle]');
    if (freccia) {
      var aperta = freccia.getAttribute('aria-expanded') !== 'true';
      freccia.setAttribute('aria-expanded', aperta ? 'true' : 'false');
      freccia.closest('.righe-sub__voce').classList.toggle('is-open', aperta);
    }
  });

  // Un link a una sezione della pagina in cui si è già (es. "La nostra storia" in
  // home) fa solo scorrere: il menu va chiuso a mano.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.menu-drawer a[href*="#"]');
    if (!link || link.pathname !== location.pathname || !link.hash) return;
    var drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });

  // Quando il menu si chiude, al prossimo giro riparte dalla lista principale.
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('.menu-drawer-container') && !e.target.open) {
      e.target.querySelectorAll('[data-righe-sub].is-open').forEach(chiudiSottomenu);
    }
  }, true);

  /* Vetrina su telefono: il titolo segue il carosello orizzontale. Ogni scheda ha
     in data-slide la frase a cui appartiene; tra due schede il titolo scorre in
     proporzione allo spostamento del dito. */
  function bindRollSlider(slider) {
    if (bound.has(slider)) return;
    bound.add(slider);
    var box = slider.closest('[data-righe-roll-mobile]');
    var pending = false;
    var sync = function () {
      pending = false;
      var cards = slider.querySelectorAll('.righe-roll__card');
      if (!cards.length) return;
      var max = slider.scrollWidth - slider.clientWidth;
      var pad = parseFloat(getComputedStyle(slider).scrollPaddingLeft) || 0;
      var x = slider.scrollLeft;
      var stops = Array.prototype.map.call(cards, function (card) {
        return Math.min(Math.max(card.offsetLeft - pad, 0), max);
      });
      var value = +cards[cards.length - 1].dataset.slide;
      for (var i = 0; i < cards.length - 1; i++) {
        if (x < stops[i + 1]) {
          var span = stops[i + 1] - stops[i];
          var f = span > 0 ? clamp01((x - stops[i]) / span) : 1;
          var a = +cards[i].dataset.slide;
          value = a + (+cards[i + 1].dataset.slide - a) * f;
          break;
        }
      }
      box.style.setProperty('--righe-roll', value.toFixed(4));
    };
    slider.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(sync);
    }, { passive: true });
    sync();
  }

  /* "I nostri tessuti": le schede partono una sopra l'altra (mazzo al centro, in alto
     nella lista, un po' sfalsate) e si aprono mentre la sezione entra nello schermo. */
  function misuraSpread(lista) {
    var schede = lista.querySelectorAll('.righe-valori__voce');
    var centro = lista.offsetWidth / 2;
    Array.prototype.forEach.call(schede, function (s, i) {
      var sfalsa = i * 14;
      s.style.setProperty('--dx', (centro - (s.offsetLeft + s.offsetWidth / 2) + sfalsa) + 'px');
      s.style.setProperty('--dy', (-s.offsetTop + sfalsa) + 'px');
      s.style.setProperty('--giro', ((i - (schede.length - 1) / 2) * 4) + 'deg');
      s.style.setProperty('--z', String(schede.length - i));
    });
  }

  function aggiornaSpread(lista, vh) {
    var r = lista.getBoundingClientRect();
    var stretto = window.innerWidth < 750;
    // Telefono: le schede sono in colonna, si aprono mentre si scorre la lista;
    // computer: in riga, si aprono quando la lista sale da 9/10 a metà schermo.
    var p = stretto ? (vh * 0.85 - r.top) / Math.max(r.height * 0.6, 1) : (vh * 0.9 - r.top) / (vh * 0.45);
    p = clamp01(p);
    lista.style.setProperty('--spread', (p * p * (3 - 2 * p)).toFixed(3));
  }

  /* Recensioni su telefono: il carosello avanza da solo di un messaggio ogni pochi
     secondi (e dopo l'ultimo torna al primo), solo quando è sullo schermo. Appena
     qualcuno lo tocca o lo scorre, l'avanzamento automatico si ferma per sempre. */
  var AUTOSCORRI_MS = 2000;

  function bindAutoScorri(lista) {
    if (bound.has(lista) || reducedMotion()) return;
    bound.add(lista);
    var visibile = false;
    var timer = null;
    var ferma = function () {
      clearInterval(timer);
      timer = null;
    };
    var passo = function () {
      var max = lista.scrollWidth - lista.clientWidth;
      if (!visibile || max <= 4) return; // computer: le recensioni sono in colonne, niente carosello
      var scheda = lista.querySelector('.righe-recensioni__voce');
      if (!scheda) return;
      var gap = parseFloat(getComputedStyle(lista).columnGap) || 0;
      var avanti = lista.scrollLeft >= max - 4 ? 0 : lista.scrollLeft + scheda.getBoundingClientRect().width + gap;
      lista.scrollTo({ left: avanti, behavior: 'smooth' });
    };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evento) {
      lista.addEventListener(evento, ferma, { passive: true });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) {
        visibile = voci[0].isIntersecting;
      }, { threshold: 0.4 }).observe(lista);
    } else {
      visibile = true;
    }
    timer = setInterval(passo, AUTOSCORRI_MS);
  }

  /* Linee in evidenza: parola attiva e foto in base allo scorrimento. */
  function setActiveWord(section, index) {
    if (section._righeActive === index) return;
    section._righeActive = index;
    section.style.setProperty('--active', index);
    section.querySelectorAll('.righe-words__word').forEach(function (el) {
      var on = +el.dataset.index === index;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && el.dataset.panel) section.style.setProperty('--panel-bg', el.dataset.panel);
    });
    section.querySelectorAll('.righe-words__image').forEach(function (el) {
      var on = +el.dataset.index === index;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
      var cta = el.querySelector('.righe-words__cta');
      if (cta) cta.tabIndex = on ? 0 : -1;
      // Il video parte solo quando la sua parola è attiva (si scarica solo allora).
      var video = el.querySelector('[data-righe-video]');
      if (video) {
        if (on && !reducedMotion()) {
          video.preload = 'auto';
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        } else {
          video.pause();
        }
      }
    });
  }

  function updateWords(section) {
    var n = parseInt(getComputedStyle(section).getPropertyValue('--count'), 10) || 1;
    var sticky = section.querySelector('.righe-words__sticky');
    var rect = section.getBoundingClientRect();
    var range = rect.height - sticky.offsetHeight;
    var p = range > 0 ? clamp01(-rect.top / range) : 0;
    var exact = Math.min(p * n, n - 0.0001);
    var index = Math.floor(exact);
    section.style.setProperty('--righe-zoom', (exact - index).toFixed(4));
    // Dopo un tocco su una parola la scelta resta finché non si scorre un po' la pagina.
    if (section._righeLockY != null && Math.abs(scrollTop() - section._righeLockY) > 160) {
      section._righeLockY = null;
      section._righeHover = false;
    }
    if (!section._righeHover) setActiveWord(section, index);
    agganciaWords(section, rect, range, n);
  }

  /* Telefono: dentro "Le nostre collezioni" ogni passata del dito si ferma sulla
     collezione successiva, e l'ultima si ferma all'inizio della sezione dopo (niente
     "volata" fino in fondo alla pagina). Funziona con lo scroll-snap della pagina,
     attivo solo mentre la sezione è bloccata sullo schermo. */
  var telefono = window.matchMedia('(max-width: 749px)');
  var AGGANCIO_SPENTO = true;

  function agganciaWords(section, rect, range, n) {
    var root = document.documentElement;
    // Spento: su iPhone (Safari e browser di Instagram) lo snap obbligatorio tratteneva la
    // pagina dentro la sezione, e scorrere in su o saltare a una sezione dal menu la bloccava.
    if (AGGANCIO_SPENTO || !telefono.matches || reducedMotion() || range <= 0) {
      root.classList.remove('righe-snap-y');
      return;
    }
    var punti = section._righeSnap;
    if (!punti) {
      punti = [];
      for (var i = 0; i <= n; i++) {
        var punto = document.createElement('span');
        punto.className = 'righe-words__snap';
        punto.setAttribute('aria-hidden', 'true');
        section.appendChild(punto);
        punti.push(punto);
      }
      section._righeSnap = punti;
    }
    var header = parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 72;
    // Un punto a metà di ogni collezione (la prima dall'inizio) e uno a fine sezione,
    // così la sezione dopo si ferma appena sotto l'intestazione.
    for (var k = 0; k < n; k++) {
      punti[k].style.top = (k === 0 ? 0 : ((k + 0.5) / n) * range) + 'px';
    }
    punti[n].style.top = (rect.height - header) + 'px';
    var dentro = rect.top <= 2 && rect.bottom > header + 2;
    root.classList.toggle('righe-snap-y', dentro);
  }

  /* Mega menu "Shop": la categoria sotto il mouse (o con il focus) mostra i suoi
     prodotti e la sua foto nella card. */
  function bindMegaMenus() {
    document.querySelectorAll('[data-righe-mega]').forEach(function (mega) {
      if (bound.has(mega)) return;
      bound.add(mega);
      var activate = function (index) {
        mega.querySelectorAll('[data-tab]').forEach(function (el) {
          el.classList.toggle('is-active', el.dataset.tab === index);
        });
        mega.querySelectorAll('[data-panel]').forEach(function (el) {
          el.classList.toggle('is-active', el.dataset.panel === index);
        });
      };
      mega.querySelectorAll('[data-tab]').forEach(function (tab) {
        tab.addEventListener('mouseenter', function () { activate(tab.dataset.tab); });
        tab.addEventListener('focus', function () { activate(tab.dataset.tab); });
      });
    });
  }

  function bindWordHover(section) {
    if (bound.has(section)) return;
    bound.add(section);
    section.querySelectorAll('.righe-words__word').forEach(function (word) {
      var activate = function () {
        section._righeHover = true;
        setActiveWord(section, +word.dataset.index);
      };
      word.addEventListener('mouseenter', activate);
      word.addEventListener('focus', activate);
      word.addEventListener('click', function () {
        activate();
        section._righeLockY = scrollTop();
      });
    });
    var panel = section.querySelector('.righe-words__panel');
    var release = function () {
      if (section._righeLockY != null) return;
      section._righeHover = false;
      updateWords(section);
    };
    panel.addEventListener('mouseleave', release);
    panel.addEventListener('focusout', function (e) {
      if (!panel.contains(e.relatedTarget)) release();
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  /* Horizon su desktop fa scorrere .page-wrapper invece della finestra. */
  function scrollTop() {
    var wrapper = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight;

    if (heroMedia) {
      var p = Math.min(Math.max(scrollTop() / vh, 0), 1);
      heroMedia.style.setProperty('--righe-hero-progress', p.toFixed(3));
    }

    stacks.forEach(function (stack) {
      var cards = stack.querySelectorAll('.righe-stack__card');
      for (var i = 0; i < cards.length - 1; i++) {
        var card = cards[i].getBoundingClientRect();
        var next = cards[i + 1].getBoundingClientRect();
        var covered = (card.bottom - next.top) / card.height;
        var p = Math.min(Math.max(covered, 0), 1);
        cards[i].style.setProperty('--righe-stack-progress', p.toFixed(3));
      }
    });

    rolls.forEach(function (section) { updateRoll(section, vh); });
    spreads.forEach(function (lista) { aggiornaSpread(lista, vh); });
    wordSections.forEach(updateWords);
  }

  /* ---------------------------------------------------------- avvio */

  function init() {
    scan();
    update();
    // In cattura, così riceve sia lo scroll della finestra sia quello di .page-wrapper.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('load', function () {
      spreads.forEach(misuraSpread);
      onScroll();
    });
    window.addEventListener('resize', function () {
      spreads.forEach(misuraSpread);
      onScroll();
    });

    // Contenuti aggiunti dopo (filtri collezione, editor del tema, ecc.)
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(scan, 100);
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', scan);
  }

  /* Slider del prezzo nei filtri (snippets/price-filter.liquid): con delega sul
     documento, perché i filtri vengono ridisegnati a ogni ricerca. */
  function priceSlider(el) {
    return el.closest('[data-righe-price-slider]');
  }

  function aggiornaBarra(slider) {
    var min = slider.querySelector('[data-righe-thumb="min"]');
    var max = slider.querySelector('[data-righe-thumb="max"]');
    var tot = Number(min.max) || 1;
    slider.style.setProperty('--from', (Number(min.value) / tot) * 100 + '%');
    slider.style.setProperty('--to', (Number(max.value) / tot) * 100 + '%');
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    var slider = priceSlider(t);
    var facet = t.closest('price-facet-component');
    if (slider && t.dataset.righeThumb) {
      var min = slider.querySelector('[data-righe-thumb="min"]');
      var max = slider.querySelector('[data-righe-thumb="max"]');
      if (Number(min.value) > Number(max.value)) {
        if (t === min) min.value = max.value; else max.value = min.value;
      }
      aggiornaBarra(slider);
      if (facet) {
        var minInput = facet.querySelector('input[name$=".gte"]');
        var maxInput = facet.querySelector('input[name$=".lte"]');
        if (minInput) minInput.value = Number(min.value) > 0 ? min.value : '';
        if (maxInput) maxInput.value = Number(max.value) < Number(max.max) ? max.value : '';
      }
    } else if (facet && t.matches('input[name*="price"]')) {
      var s = facet.querySelector('[data-righe-price-slider]');
      if (!s) return;
      var val = parseFloat(String(t.value).replace(/\./g, '').replace(',', '.'));
      var thumb = s.querySelector('[data-righe-thumb="' + (/\.gte$/.test(t.name) ? 'min' : 'max') + '"]');
      thumb.value = isNaN(val) ? (thumb.dataset.righeThumb === 'min' ? 0 : thumb.max) : Math.round(val);
      aggiornaBarra(s);
    }
  });

  /* Acquisto su telefono (blocks/righe-acquisto.liquid): la barra d'acquisto in fondo allo
     schermo apre il menu con taglie, colori e "Aggiungi al carrello". Lo stato aperto sta
     sull'elemento <html>, perché il tema ridisegna il blocco quando si cambia variante. */
  var telefono = window.matchMedia('(max-width: 749px)');

  function menuAcquisto(aperto) {
    if (!document.querySelector('[data-righe-acquisto]')) return;
    root.classList.toggle('righe-acquisto-aperto', aperto);
    if (aperto) {
      var primo = document.querySelector('[data-righe-acquisto] input:not([disabled]), [data-righe-acquisto] button');
      if (primo) primo.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    if (!telefono.matches || !document.querySelector('[data-righe-acquisto]')) return;
    var t = e.target;
    if (t.closest('.sticky-add-to-cart__bar')) {
      // In cattura, prima del tema: il carrellino apre il menu invece di aggiungere subito.
      e.preventDefault();
      e.stopImmediatePropagation();
      menuAcquisto(true);
    } else if (t.closest('[data-righe-acquisto-chiudi]')) {
      menuAcquisto(false);
    } else if (t.closest('[data-righe-acquisto] [ref="addToCartButton"]')) {
      // Dopo l'aggiunta si apre il carrello: il menu si chiude.
      setTimeout(function () { menuAcquisto(false); }, 700);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('righe-acquisto-aperto')) menuAcquisto(false);
  });

  telefono.addEventListener('change', function () { menuAcquisto(false); });

  /* Disponibilità incrociata: il tema barra una taglia che manca nel colore scelto, ma non un
     colore che manca nella taglia scelta (guarda solo le scelte precedenti). Qui ogni valore
     si confronta con tutte le altre scelte, usando l'elenco delle combinazioni scritto nel
     blocco Acquisto. Il tema riscrive i pulsanti a ogni cambio: l'osservatore li ricorregge. */
  function segnaDisponibili() {
    document.querySelectorAll('[data-righe-acquisto]').forEach(function (box) {
      var dati = box.querySelector('script[data-righe-varianti]');
      if (!dati) return;
      var varianti;
      try { varianti = JSON.parse(dati.textContent); } catch (err) { return; }
      var gruppi = {};
      box.querySelectorAll('input[data-fieldset-index]').forEach(function (input) {
        var i = +input.dataset.fieldsetIndex;
        (gruppi[i] = gruppi[i] || []).push(input);
      });
      var indici = Object.keys(gruppi).map(Number);
      if (indici.length < 2) return;
      var scelti = {};
      indici.forEach(function (i) {
        var c = gruppi[i].filter(function (x) { return x.checked; })[0];
        if (c) scelti[i] = c.value;
      });
      indici.forEach(function (i) {
        gruppi[i].forEach(function (input) {
          var ok = varianti.some(function (v) {
            if (!v.a || v.o[i] !== input.value) return false;
            return indici.every(function (j) { return j === i || scelti[j] == null || v.o[j] === scelti[j]; });
          });
          var valore = ok ? 'true' : 'false';
          if (input.getAttribute('data-option-available') !== valore) {
            input.setAttribute('data-option-available', valore);
            if (ok) input.removeAttribute('aria-disabled'); else input.setAttribute('aria-disabled', 'true');
          }
        });
      });
    });
  }

  var segnaInAttesa = false;
  function segnaPresto() {
    if (segnaInAttesa) return;
    segnaInAttesa = true;
    requestAnimationFrame(function () { segnaInAttesa = false; segnaDisponibili(); });
  }

  if (document.querySelector('[data-righe-acquisto]')) {
    segnaDisponibili();
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-righe-acquisto]')) segnaPresto();
    });
    new MutationObserver(segnaPresto).observe(document.querySelector('[data-righe-acquisto]').parentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['data-option-available', 'checked'],
    });
  }

  /* Colori del capo (snippets/righe-colori-capo.liquid): la miniatura preme il pulsante
     vero della scelta varianti (stesso identificativo del colore), così il tema aggiorna
     foto, prezzo, disponibilità e barra d'acquisto, e il carrello ha già quel colore. */
  document.addEventListener('click', function (e) {
    var voce = e.target.closest('[data-righe-colore-id]');
    if (!voce) return;
    var id = voce.dataset.righeColoreId;
    var input = document.querySelector('[data-righe-acquisto] input[data-option-value-id="' + id + '"]') ||
      document.querySelector('variant-picker input[data-option-value-id="' + id + '"]');
    if (!input) return;
    var riga = voce.closest('[data-righe-colori-capo]');
    riga.querySelectorAll('[data-righe-colore-id]').forEach(function (b) {
      var scelto = b === voce;
      b.classList.toggle('is-scelto', scelto);
      b.setAttribute('aria-pressed', scelto ? 'true' : 'false');
    });
    var etichetta = riga.querySelector('.righe-colori-capo__scelto');
    if (etichetta) etichetta.textContent = voce.dataset.righeColoreNome;
    if (!input.checked) input.click();
  });

  /* Cerchietti dei colori sulle schede (snippets/righe-pallini-capo.liquid): il primo tocco
     mostra la foto di quel colore e fa puntare la scheda a quel colore; il secondo tocco, o
     un tocco sulla foto, apre il capo. Col mouse la foto cambia già al passaggio. */
  function schedaDi(pallino) {
    return pallino.closest('product-card, .resource-card');
  }

  function mostraFotoColore(scheda, pallino) {
    var id = pallino.dataset.fotoId;
    if (scheda.previewVariant && scheda.querySelector('[slide-id="' + id + '"]')) {
      scheda.previewVariant(id);
      return;
    }
    var img = scheda.querySelector('.resource-card__image, .product-card__content img');
    if (img && pallino.dataset.foto) {
      img.removeAttribute('srcset');
      img.src = pallino.dataset.foto;
    }
  }

  function scegliColore(scheda, pallino) {
    var precedente = scheda.querySelector('.righe-pallino[aria-current]');
    if (precedente) precedente.removeAttribute('aria-current');
    pallino.setAttribute('aria-current', 'true');
    scheda.setAttribute('data-righe-colore-scelto', '');
    mostraFotoColore(scheda, pallino);

    if (scheda.applyVariantToLinks) {
      scheda.applyVariantToLinks(pallino.dataset.righePallino);
      if (scheda.refs && scheda.refs.quickAdd && scheda.refs.quickAdd.fetchProductPage) {
        scheda.refs.quickAdd.fetchProductPage(scheda.productPageUrl);
      }
    } else {
      var link = scheda.querySelector('.resource-card__link');
      if (link) link.href = pallino.href;
    }
    var prezzo = scheda.querySelector('.price bdi');
    if (prezzo && pallino.dataset.prezzo) prezzo.textContent = pallino.dataset.prezzo;
  }

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || !(e.target instanceof Element)) return;
    var pallino = e.target.closest('a.righe-pallino');
    // Colore già scelto o senza foto propria: il link apre il capo.
    if (!pallino || !pallino.dataset.fotoId || pallino.hasAttribute('aria-current')) return;
    var scheda = schedaDi(pallino);
    if (!scheda) return;
    e.preventDefault();
    e.stopPropagation();
    scegliColore(scheda, pallino);
  }, true);

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !(e.target instanceof Element)) return;
    var pallino = e.target.closest('a.righe-pallino[data-foto-id]');
    if (pallino && !pallino.contains(e.relatedTarget)) mostraFotoColore(schedaDi(pallino), pallino);
  });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || !(e.target instanceof Element)) return;
    var pallino = e.target.closest('a.righe-pallino[data-foto-id]');
    if (!pallino || pallino.contains(e.relatedTarget)) return;
    var scheda = schedaDi(pallino);
    var scelto = scheda.querySelector('.righe-pallino[aria-current][data-foto-id]');
    // Nessun colore toccato: la scheda torna alla sua foto iniziale.
    if (scheda.resetVariant && !scheda.hasAttribute('data-righe-colore-scelto')) scheda.resetVariant();
    else if (scelto) mostraFotoColore(scheda, scelto);
  });

  /* Dove trovarci (sections/righe-orari-faq.liquid): "Siamo al banco adesso" oppure
     "Prossimo mercato: ...", calcolato sull'ora italiana; la scheda di quel giorno
     viene messa in evidenza. */
  var GIORNI_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var formatoRoma = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Rome', weekday: 'short', day: 'numeric', month: 'numeric',
    hour: 'numeric', minute: 'numeric', hour12: false,
  });

  function oraRoma(data) {
    var p = {};
    formatoRoma.formatToParts(data).forEach(function (x) { p[x.type] = x.value; });
    return { g: GIORNI_EN.indexOf(p.weekday), giorno: +p.day, mese: +p.month, minuti: (+p.hour % 24) * 60 + +p.minute };
  }

  function inMinuti(ora) {
    var p = String(ora).split(/[:.]/);
    return (+p[0] || 0) * 60 + (+p[1] || 0);
  }

  /* Stagione come "dal giorno/mese al giorno/mese", anche a cavallo dell'anno (es. ottobre-maggio). */
  function inStagione(o, r) {
    var inizio = o.m1 * 100 + (o.g1 || 1);
    var fine = o.m2 * 100 + (o.g2 || 31);
    var oggi = r.mese * 100 + r.giorno;
    return inizio <= fine ? oggi >= inizio && oggi <= fine : oggi >= inizio || oggi <= fine;
  }

  function statoBanco(el) {
    var orari;
    try { orari = JSON.parse(el.dataset.righeBanco); } catch (e) { return; }
    var giorni = (el.dataset.giorni || '').split(',');
    var mesi = (el.dataset.mesi || '').split(',');
    var sezione = el.closest('.righe-banco');
    var adesso = Date.now();

    for (var i = 0; i < 15; i++) {
      var r = oraRoma(new Date(adesso + i * 86400000));
      for (var k = 0; k < orari.length; k++) {
        var o = orari[k];
        if (o.g !== r.g || !inStagione(o, r)) continue;
        if (i === 0 && r.minuti >= inMinuti(o.a)) continue;

        // Frasi tradotte dal tema (locales: righe.banco.*), con i segnaposto {dove}, {inizio}...
        var t = el.dataset;
        var valori = {
          dove: o.c ? (t.tDove || ' {citta}').replace('{citta}', o.c) : '',
          inizio: o.da,
          fine: o.a,
          giorno: 'giorniMinuscoli' in t ? (giorni[r.g] || '').toLowerCase() : giorni[r.g] || '',
          data: r.giorno + ' ' + (mesi[r.mese - 1] || ''),
        };
        var aperto = i === 0 && r.minuti >= inMinuti(o.da);
        var modello = aperto ? t.tAdesso : i === 0 ? t.tOggi : i === 1 ? t.tDomani : t.tProssimo;
        var testo = String(modello || '').replace(/\{(\w+)\}/g, function (m, k) {
          return k in valori ? valori[k] : m;
        });

        el.textContent = testo;
        el.classList.toggle('is-aperto', aperto);
        el.hidden = false;
        if (sezione) {
          sezione.querySelectorAll('.righe-banco__giorno').forEach(function (li, n) {
            li.classList.toggle('is-prossimo', n === k);
          });
        }
        return;
      }
    }
    el.hidden = true;
  }

  function aggiornaBanchi() {
    document.querySelectorAll('[data-righe-banco]').forEach(statoBanco);
  }

  aggiornaBanchi();
  document.addEventListener('DOMContentLoaded', aggiornaBanchi);
  document.addEventListener('shopify:section:load', aggiornaBanchi);
  setInterval(aggiornaBanchi, 60000);

  window.RigheMotion = { scan: scan, update: update, revealInViewport: revealInViewport };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
